<script setup lang="ts">
import type { GameVehicleSummary } from "~~/types/gamedata";

const props = defineProps<{ vehicle: GameVehicleSummary }>();

const detailHref = computed(() => `/shipexkurs/ships/${props.vehicle.id}`);
</script>

<template>
  <NuxtLink
    :to="detailHref"
    class="group flex flex-col overflow-hidden rounded-lg bg-bunker-950 ring-1 ring-white/10 transition-all duration-300 hover:ring-primary/50 hover:-translate-y-0.5"
  >
    <div class="relative aspect-video overflow-hidden">
      <ShipexkursShipImage
        :vehicle="vehicle"
        img-class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
      <div class="absolute inset-0 bg-gradient-to-t from-woodsmoke-950 via-transparent to-transparent" />
      <UBadge
        v-if="vehicle.productionStatus"
        :label="vehicle.productionStatus"
        :color="vehicle.isConcept ? 'warning' : 'success'"
        variant="subtle"
        size="sm"
        class="absolute left-2 top-2"
      />
      <UBadge
        v-if="vehicle.sizeLabel"
        :label="vehicle.sizeLabel"
        color="neutral"
        variant="subtle"
        size="sm"
        class="absolute right-2 top-2"
      />
    </div>
    <div class="flex flex-1 flex-col gap-1 p-3">
      <h3 class="!my-0 truncate text-sm font-semibold text-white group-hover:text-primary">
        {{ vehicle.name }}
      </h3>
      <p class="!my-0 truncate text-xs text-neutral-400">
        {{ vehicle.manufacturer.name ?? "Unbekannter Hersteller" }}
      </p>
      <p v-if="vehicle.role || vehicle.career" class="!my-0 truncate text-xs text-neutral-500">
        {{ vehicle.role ?? vehicle.career }}
      </p>
    </div>
  </NuxtLink>
</template>
